module.exports = __webpack_public_path__ + "img/tel_phone.c73d17b1.png";